import { publicAxios } from 'common/utils/axios'

// Endpoint
import { ADDRESS_ENDPOINTS } from 'common/constants/apiUrls'

// export const authAxiosLocalServer = createAxiosInstance(USER_SERVICE_URL)

const handler = publicAxios

export const GetAddressVerification = async ({ cipher_text }) => {
  const response = await handler.get(`${ADDRESS_ENDPOINTS.GET_ADDRESS_VERIFICATION}/${cipher_text}`)

  const { data } = response.data

  return data
}

export const PostAddressVerification = async ({ signature, cipher_text, pubkey = null }) => {
  const response = await handler.post(`${ADDRESS_ENDPOINTS.POST_ADDRESS_VERIFICATION}/${cipher_text}`, {
    signature,
    pubkey,
  })

  const { data } = response.data

  return data
}
